<template>
  <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
    <section>
      <b-card title="Master Help">
        <b-tabs pills fill>
          <b-tab @click="link('help')">
            <template #title>
              <feather-icon icon="ListIcon" />
              <span>List Help</span>
            </template>
          </b-tab>
          <b-tab active>
            <template #title>
              <feather-icon icon="FilePlusIcon" />
              <span>{{changeTitle}}</span>
            </template>
          </b-tab>
          <b-tab @click="link('help-category')">
            <template #title>
              <feather-icon icon="FileIcon" />
              <span>Category</span>
            </template>
          </b-tab>
          <b-tab @click="link('help-sub-category')">
            <template #title>
              <feather-icon icon="FileIcon" />
              <span>Sub Category</span>
            </template>
          </b-tab>
        </b-tabs>
      </b-card>
      <b-card>
        <!-- <b-card-text>Help.</b-card-text> -->
        <validation-observer ref="simpleRules">
          <b-form @submit.prevent>
          <b-row>
            <!-- SubCategory -->
            <b-col cols="12">
              <b-form-group label="SubCategory" label-for="v-SubCategory">
                <validation-provider #default="{ errors }"  name="SubCategory">
                  <v-select id="v-SubCategory" v-model="form.select_1" placeholder="Chose Sub Category" autocomplete="off" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" label="title" :options="subCategoryOptions" :reduce="subCategoryOptions => subCategoryOptions.value"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Title -->
            <b-col cols="12">
              <b-form-group label="Title" label-for="v-Title">
                <validation-provider #default="{ errors }"  name="Title" rules="required">
                  <b-form-input  id="v-Title" :state="errors.length > 0 ? false:null" v-model="form.text_2" placeholder="Title" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- SubTitle -->
            <b-col cols="12">
              <b-form-group label="SubTitle" label-for="v-SubTitle">
                <validation-provider #default="{ errors }"  name="SubTitle" rules="required">
                  <b-form-input  id="v-SubTitle" :state="errors.length > 0 ? false:null" v-model="form.text_3" placeholder="SubTitle" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Help -->
            <b-col cols="12">
              <b-form-group label="Help" label-for="v-Help">
                <validation-provider #default="{ errors }"  name="Help">
                  <quill-editor autocomplete="off" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"  v-model="form.content_4" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- isDraft -->
            <b-col cols="1">
              <b-form-group label="isDraft" label-for="v-isDraft">
                <b-form-checkbox
                  checked="true"
                  class="custom-control-primary"
                  name="check-button"
                  v-model="form.checkbox_5"
                  switch
                >
                  <span class="switch-icon-left">
                    <feather-icon icon="FileTextIcon" />
                  </span>
                  <span class="switch-icon-right">
                    <feather-icon icon="FileTextIcon" />
                  </span>
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <!-- isMobile -->
            <b-col cols="1">
              <b-form-group label="isMobile" label-for="v-isMobile">
                <b-form-checkbox
                  checked="true"
                  class="custom-control-primary"
                  name="check-button"
                  v-model="form.checkbox_6"
                  switch
                >
                  <span class="switch-icon-left">
                    <feather-icon icon="SmartphoneIcon" />
                  </span>
                  <span class="switch-icon-right">
                    <feather-icon icon="SmartphoneIcon" />
                  </span>
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <!-- isHighlight -->
            <b-col cols="1">
              <b-form-group label="isHighlight" label-for="v-isHighlight">
                <b-form-checkbox
                  checked="true"
                  class="custom-control-primary"
                  name="check-button"
                  v-model="form.checkbox_7"
                  switch
                >
                  <span class="switch-icon-left">
                    <feather-icon icon="MaximizeIcon" />
                  </span>
                  <span class="switch-icon-right">
                    <feather-icon icon="MaximizeIcon" />
                  </span>
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <!-- submit and reset -->
            <b-col cols="12">
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1" @click.prevent="validationForm"> Submit </b-button>
              <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" type="reset" variant="outline-secondary"> Reset </b-button>
            </b-col>
          </b-row>
          </b-form>
        </validation-observer>
      </b-card>
    </section>
  </b-overlay>
</template>
<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BRow, BTabs, BTab, BOverlay, BCol, BFormCheckbox, BFormGroup, BFormInput, BForm, BButton, BCard } from 'bootstrap-vue'
import { required } from '@validations'
import { mapState } from 'vuex'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import router from '@/router/index.js'
export default {
  components: { vSelect, quillEditor, BOverlay, ValidationProvider, ValidationObserver, BFormCheckbox, BCard, BRow, BTabs, BTab, BCol, BFormGroup, BFormInput, BForm, BButton },
  directives: { Ripple },
  data () {
    return { 
      changeTitle: 'Create Help',
      genderOptions: [
        { text: 'Male', value: 'M' },
        { text: 'Female', value: 'F' },
      ],
      form: {id: null, select_1: '', text_2: '', text_3: '', content_4: '', checkbox_5: '', checkbox_6: '', checkbox_7: ''},
      show: false,
      required 
    }
  },
  computed: {
    ...mapState({ subCategoryOptions: state => state.helpSubCategory.options}),
    select_6() {
      return this.form.select_6;
    }
  },
  created () {
    this.$store.dispatch('helpSubCategory/getAll')
  },
  methods: {
    link (link) {
      router.push({ name: link })
    },
    category () {
      router.push({ name: 'help-category' })
    },
    subCategory () {
      router.push({ name: 'help-sub-category' })
    },
    validationForm () {
      this.show = true
      this.$refs.simpleRules.validate()
      .then(success => {
        if (success) {
          const formData = this.form 
			    this.$store.dispatch('help/formPostPut', formData)
          .then(res => {
            this.notification('Success','CheckIcon','success','You have successfully')
          }, 
          err => {
            this.show = false
            this.notification('Failed','CloseIcon','danger','You have unsuccessful')
          })
        } else {
          this.show = false
          this.notification('Failed','CloseIcon','danger','You have unsuccessful')
        }
      })
    },
    notification (a,b,c,d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: { title: a, icon: b, variant: c, text: d}
      })
    },
    getData (id) {
			this.$store.dispatch('help/getById', id).then(data => {
        this.form.id = data.id
        this.form.select_1 = data.artc_sub_ctgr_id
        this.form.text_2 = data.title
        this.form.text_3 = data.sub_title
        this.form.content_4 = data.content
        this.form.checkbox_5 = data.is_draft === 'Y' ? true : false,
        this.form.checkbox_6 = data.is_mobile === 'Y' ? true : false,
        this.form.checkbox_7 = data.is_highlight === 'Y' ? true : false,
        this.show = false
      })
    }
  },
  mounted () {
    if (this.$route.params.id) {
      this.show = true
      this.changeTitle = 'Update Help'
      this.getData(this.$route.params.id)
    }
  }
}
</script>
<style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';
</style>